// extracted by mini-css-extract-plugin
module.exports = {"cls1":"contacts-Main-module--cls1--3PpiL","cls2":"contacts-Main-module--cls2--1mla7 contacts-Main-module--cls1--3PpiL"};